/** Supported FAQ category identifiers used for routing and icons. */
export const FAQ_CATEGORY_IDS = ["users", "managers"] as const;

export type FaqCategoryId = (typeof FAQ_CATEGORY_IDS)[number];

/** Maps each FAQ category id to a short icon label shown on hub cards. */
export const FAQ_CATEGORY_ICONS: Record<FaqCategoryId, string> = {
  users: "U",
  managers: "M",
};

/**
 * Checks whether a string is a valid FAQ category id.
 * Used by dynamic routes to reject unknown categories.
 */
export function isFaqCategoryId(value: string): value is FaqCategoryId {
  return (FAQ_CATEGORY_IDS as readonly string[]).includes(value);
}
